import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  OsaComment,
  CreateOsaComment,
  UpdateOsaComment,
} from "../models/OsaComment";

export const OsaCommentApi = {
  get: async (commentId: string) => {
    return await jwtAuthAxios().get<OsaComment>(`/osa-comments/${commentId}`);
  },

  create: async (comment: CreateOsaComment) => {
    return await jwtAuthAxios().post<OsaComment>(`/osa-comments`, comment);
  },

  update: async (commentId: string, body: UpdateOsaComment) => {
    return await jwtAuthAxios().put<OsaComment>(
      `/osa-comments/${commentId}`,
      body
    );
  },

  resolve: async (commentId: string) => {
    return await jwtAuthAxios().put<OsaComment>(
      `/osa-comments/${commentId}/resolve`
    );
  },

  unresolve: async (commentId: string) => {
    return await jwtAuthAxios().put<OsaComment>(
      `/osa-comments/${commentId}/unresolve`
    );
  },

  delete: async (commentId: string) => {
    return await jwtAuthAxios().delete<OsaComment>(
      `/osa-comments/${commentId}`
    );
  },
};
